<div *ngIf="loading" class="loading-style">
  <app-loading-spinner></app-loading-spinner>
</div>

<!-- Con un PDF abierto el consentimiento ya está diligenciado: no se vuelve a la lista -->
<ng-container *ngIf="config && !checkingPdf && !pdfUrl" [ngSwitch]="templateId">
  <!-- Un componente por diseño de landing; LandingDesign5 es el diseño por defecto -->
  <app-landing-design-1 *ngSwitchCase="'landing_1'" [config]="config" (selectForm)="onSelectForm($event)"></app-landing-design-1>
  <app-landing-design-2 *ngSwitchCase="'landing_2'" [config]="config" (selectForm)="onSelectForm($event)"></app-landing-design-2>
  <app-landing-design-3 *ngSwitchCase="'landing_3'" [config]="config" (selectForm)="onSelectForm($event)"></app-landing-design-3>
  <app-landing-design-4 *ngSwitchCase="'landing_4'" [config]="config" (selectForm)="onSelectForm($event)"></app-landing-design-4>
  <app-landing-design-5 *ngSwitchDefault [config]="config" (selectForm)="onSelectForm($event)"></app-landing-design-5>
</ng-container>

<!-- Confirmación de selección -->
<div class="landing-overlay" *ngIf="confirmForm" (click)="onCancelConfirm()">
  <div class="landing-alert" (click)="$event.stopPropagation()">
    <div class="landing-alert-icon">!</div>
    <h2>¿Está seguro?</h2>
    <p>Acaba de seleccionar {{ confirmForm.title }}</p>
    <div class="landing-alert-actions">
      <button type="button" class="btn-alert-cancel" (click)="onCancelConfirm()">Cancelar</button>
      <button type="button" class="btn-alert-ok" (click)="onAcceptConfirm()">OK</button>
    </div>
  </div>
</div>

<!-- Vista del consentimiento -->
<div class="landing-fullscreen" *ngIf="viewForm">
  <div class="landing-viewer">
    <div class="landing-viewer-header">
      <button *ngIf="!pdfUrl" type="button" class="landing-viewer-back" (click)="onCloseView()">
        <span class="material-icons">arrow_back</span>
        Volver
      </button>
      <span class="landing-viewer-title">{{ viewForm.number }} · {{ viewForm.title }}</span>
    </div>

    <!-- Formulario ya diligenciado: su PDF -->
    <iframe *ngIf="pdfUrl" class="landing-viewer-content" [src]="pdfUrl" title="PDF del consentimiento"></iframe>

    <iframe
      *ngIf="!pdfUrl && !fillUrl"
      class="landing-viewer-content"
      sandbox
      [srcdoc]="viewHtml"
      title="Consentimiento"
    ></iframe>
    <ng-container *ngIf="fillUrl">
      <iframe class="landing-viewer-content landing-viewer-fill" [src]="fillUrl" title="Formulario"></iframe>
    </ng-container>

    <div class="landing-viewer-footer" *ngIf="!fillUrl && !pdfUrl && (hasAcceptance(viewForm) || hasNegation(viewForm))">
      <ng-container *ngIf="hasAcceptance(viewForm) && hasNegation(viewForm); else singleAction">
        <p>¿Acepta el procedimiento?</p>
        <div class="landing-viewer-actions">
          <button type="button" class="btn-yes" (click)="openForm(viewForm.acceptance_form_id)">Sí</button>
          <button type="button" class="btn-no" (click)="openForm(viewForm.negatino_form_id)">No</button>
        </div>
      </ng-container>
      <ng-template #singleAction>
        <div class="landing-viewer-actions">
          <button
            type="button"
            class="btn-yes"
            (click)="openForm(viewForm.acceptance_form_id || viewForm.negatino_form_id)"
          >
            Continuar
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
